module.exports = __webpack_public_path__ + "assets/img/0201.ce55b2a0.svg";